// // frontend/src/components/Admin/AssignDevice.js
// import React, { useState } from "react";
// import axios from "axios";
// import { Form, Button, Alert, Spinner } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import "./AdminCSS/operations.css";

// const API_URL = process.env.REACT_APP_API_URL;


// const AssignDevice = () => {
//   const [deviceId, setDeviceId] = useState("");
//   const [patientId, setPatientId] = useState("");
//   const [status, setStatus] = useState("inactive");
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleAssign = async (e) => {
//     e.preventDefault();
//     setMessage(null);
//     setError(null);
//     setLoading(true);

//     try {
//       // 1. Assign device to patient
//       await axios.post(`${API_URL}/device-assignments/assign-device`, {
//         device_id: Number(deviceId),
//         patient_id: Number(patientId),
//       });

//       // 2. Update status using dropdown selection
//       await axios.put(`${API_URL}/device-assignments/device-status`, {
//         device_id: Number(deviceId),
//         status: status,
//       });

//       setMessage(`Device successfully assigned and status set to "${status}".`);
//       setDeviceId("");
//       setPatientId("");
//       setStatus("inactive");
//     } catch (err) {
//       setError(
//         err.response?.data?.detail ||
//         err.response?.data ||
//         "Unable to assign device or update status. Check inputs."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClose = () => {
//     navigate("/admindashboard");
//   };

//   return (
//     <div className="add-patient-wrapper">
//       <div className="add-patient-container">
//         <div className="header">
//           <h3>Assign Device to Patient</h3>
//           <button className="close-button" onClick={handleClose}>
//             &times;
//           </button>
//         </div>

//         {message && <Alert variant="success">{message}</Alert>}
//         {error && (
//           <Alert variant="danger">
//             {typeof error === "object" ? JSON.stringify(error) : error}
//           </Alert>
//         )}

//         <Form onSubmit={handleAssign}>
//           <Form.Group>
//             <Form.Label>Device ID</Form.Label>
//             <Form.Control
//               type="number"
//               placeholder="Enter Device ID"
//               value={deviceId}
//               onChange={(e) => setDeviceId(e.target.value.replace(/\D/g, ""))}
//               required
//             />
//           </Form.Group>

//           <Form.Group>
//             <Form.Label>Patient ID</Form.Label>
//             <Form.Control
//               type="number"
//               placeholder="Enter Patient ID"
//               value={patientId}
//               onChange={(e) => setPatientId(e.target.value.replace(/\D/g, ""))}
//               required
//             />
//           </Form.Group>

//           <Form.Group>
//             <Form.Label>Device Status</Form.Label>
//             <Form.Select
//               value={status}
//               onChange={(e) => setStatus(e.target.value)}
//               required
//             >
//               <option value="inactive">Inactive</option>
//               <option value="active">Active</option>
//             </Form.Select>
//           </Form.Group>

//           <Button type="submit" className="btn btn-primary mt-3" disabled={loading}>
//             {loading ? (
//               <>
//                 <Spinner animation="border" size="sm" className="me-2" /> Assigning...
//               </>
//             ) : (
//               "Assign Device"
//             )}
//           </Button>
//         </Form>
//       </div>
//     </div>
//   );
// };

// export default AssignDevice;


// frontend/src/components/Admin/AssignDevice.js
import React, { useState } from "react";
import axios from "axios";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./AdminCSS/operations.css";

const API_URL = process.env.REACT_APP_API_URL;

const AssignDevice = () => {
  const [deviceId, setDeviceId] = useState("");
  const [patientId, setPatientId] = useState("");
  const [status, setStatus] = useState("inactive");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleAssign = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);
    setLoading(true);

    try {
      // 🔹 Retrieve token from session or local storage
      const token =
        sessionStorage.getItem("access_token") ||
        localStorage.getItem("access_token");

      if (!token) {
        setError("Unauthorized: Missing access token. Please log in again.");
        navigate("/login");
        return;
      }

      // 🔹 Assign device to patient (now includes status)
      const response = await axios.post(
        `${API_URL}/device-assignments/assign-device`,
        {
          device_id: Number(deviceId),
          patient_id: Number(patientId),
          status: status, // ✅ Send status directly from frontend
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setMessage(
        `Device successfully assigned with status "${status}".`
      );
      setDeviceId("");
      setPatientId("");
      setStatus("inactive");
    } catch (err) {
      console.error("Error assigning device:", err);
      if (err.response && err.response.status === 401) {
        setError("Unauthorized: Please log in again.");
        navigate("/login");
      } else {
        setError(
          err.response?.data?.detail ||
            err.response?.data ||
            "Unable to assign device. Check inputs or try again."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    navigate("/admindashboard");
  };

  return (
    <div className="add-patient-wrapper">
      <div className="add-patient-container">
        <div className="header">
          <h3>Assign Device to Patient</h3>
          <button className="close-button" onClick={handleClose}>
            &times;
          </button>
        </div>

        {message && <Alert variant="success">{message}</Alert>}
        {error && (
          <Alert variant="danger">
            {typeof error === "object" ? JSON.stringify(error) : error}
          </Alert>
        )}

        <Form onSubmit={handleAssign}>
          <Form.Group>
            <Form.Label>Device ID</Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter Device ID"
              value={deviceId}
              onChange={(e) => setDeviceId(e.target.value.replace(/\D/g, ""))}
              required
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Patient ID</Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter Patient ID"
              value={patientId}
              onChange={(e) => setPatientId(e.target.value.replace(/\D/g, ""))}
              required
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Device Status</Form.Label>
            <Form.Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              required
            >
              <option value="inactive">Inactive</option>
              <option value="active">Active</option>
            </Form.Select>
          </Form.Group>

          <Button
            type="submit"
            className="btn btn-primary mt-3"
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" /> Assigning...
              </>
            ) : (
              "Assign Device"
            )}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default AssignDevice;
